export default [
  {
    path: '/algorithm-runs',
    name: 'algorithm-runs',
    component: () => import('./pages/Index'),
    meta: {
      title: 'Algoritmos',
      icon: 'mdi-robot-outline',
      breadcrumbs: [
        { text: 'Algoritmos', disabled: true, href: '/' },
        { text: 'Execuções', disabled: true, href: '/' },
      ],
    },
  },
  {
    path: '/algorithm-runs/timetable',
    name: 'algorithm-runs-timetable',
    component: () => import('./pages/Index'),
    props: { algorithmKey: 'timetable' },
    meta: {
      title: 'Grade Horária',
      icon: 'mdi-calendar-clock',
      breadcrumbs: [
        { text: 'Geração Dinâmica', disabled: true, href: '/' },
        { text: 'Grade Horária', disabled: true, href: '/' },
      ],
    },
  },
  {
    path: '/algorithm-runs/teacher-attribution',
    name: 'algorithm-runs-teacher-attribution',
    component: () => import('./pages/Index'),
    props: { algorithmKey: 'teacher_attribution' },
    meta: {
      title: 'Atribuição de Professores',
      icon: 'mdi-account-tie',
      breadcrumbs: [
        { text: 'Geração Dinâmica', disabled: true, href: '/' },
        { text: 'Atribuição de Professores', disabled: true, href: '/' },
      ],
    },
  },
  {
    path: '/algorithm-runs/ambience-balance',
    name: 'algorithm-runs-ambience-balance',
    component: () => import('./pages/Index'),
    props: { algorithmKey: 'ambience_balance' },
    meta: {
      title: 'Balanceamento de Ambientes',
      icon: 'mdi-scale-balance',
      breadcrumbs: [
        { text: 'Geração Dinâmica', disabled: true, href: '/' },
        { text: 'Balanceamento de Ambientes', disabled: true, href: '/' },
      ],
    },
  },
  {
    path: '/algorithm-runs/ambience-allocation',
    name: 'algorithm-runs-ambience-allocation',
    component: () => import('./pages/Index'),
    props: { algorithmKey: 'ambience_allocation' },
    meta: {
      title: 'Alocação de Ambientes',
      icon: 'mdi-home-import-outline',
      breadcrumbs: [
        { text: 'Geração Dinâmica', disabled: true, href: '/' },
        { text: 'Alocação de Ambientes', disabled: true, href: '/' },
      ],
    },
  },
  {
    path: '/algorithm-runs/basic-education',
    name: 'algorithm-runs-basic-education',
    component: () => import('./pages/Index'),
    props: { algorithmKey: 'basic_education' },
    meta: {
      title: 'Horário Educação Básica',
      icon: 'mdi-school-outline',
      breadcrumbs: [
        { text: 'Geração Dinâmica', disabled: true, href: '/' },
        { text: 'Horário Educação Básica', disabled: true, href: '/' },
      ],
    },
  },
  {
    path: '/algorithm-runs/:runId',
    name: 'algorithm-run-show',
    component: () => import('./pages/Show'),
    meta: {
      title: 'Execução',
      icon: 'mdi-robot-outline',
    },
  },
  {
    path: '/algorithm-runs/:runId/results',
    name: 'algorithm-run-results',
    component: () => import('./pages/Results'),
    meta: {
      title: 'Resultados',
      icon: 'mdi-calendar-week-outline',
    },
  },
]
